import graphql__028d65f655bff3498f73 from "./__generated__/EmailTemplateViewQuery.graphql.ts";
import graphql__c2c9ee70683ffdb2dffe from "./__generated__/EmailTemplateViewRenameMutation.graphql.ts";import * as React from "react";
import {useState, useCallback} from "react";
import {graphql, useMutation} from "react-relay";
import {Outlet} from "react-router";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import EmailTemplateViewQuery, {EmailTemplateViewQuery as EmailTemplateViewQueryType} from "./__generated__/EmailTemplateViewQuery.graphql";
import SecondaryNavigation from "./navigation/SecondaryNavigation";
import MarketingHeader from "./presentational/MarketingHeader";
import {useIntl} from "react-intl";

type EmailTemplateViewParams = {
    prepared: any
};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type EmailTemplateViewProps = EmailTemplateViewParams & ConnectedProps<typeof connector>;

const EmailTemplateView: React.FC<EmailTemplateViewProps> = (props) => {
    const intl = useIntl();
    const [isSaving, setIsSaving] = useState(false);

    const {emailTemplate, emailLayouts} = usePreloadedQuery<EmailTemplateViewQueryType>(
        graphql__028d65f655bff3498f73,
        props.prepared.emailTemplateViewQuery,
    );

    const [commitRenameMutation] = useMutation(graphql__c2c9ee70683ffdb2dffe);

    const handleTitleEdit = useCallback((newTitle: string) => {
        if (!emailTemplate) return;
        setIsSaving(true);
        commitRenameMutation({
            variables: {
                input: {
                    id: emailTemplate.id,
                    name: newTitle,
                }
            },
            onCompleted: () => {
                setIsSaving(false);
            },
            onError: () => {
                setIsSaving(false);
            },
        });
    }, [emailTemplate, commitRenameMutation]);

    if (emailTemplate == null) {
        return <p>{intl.formatMessage({id: 'emailTemplate.notFound'})}</p>;
    }

    // Badge for usage count
    const usageCount = emailTemplate.usageCount;
    const usageBadge = {
        value: usageCount === 0 ? 'DRAFT' : 'USED',
        label: usageCount === 0
            ? intl.formatMessage({id: 'emailTemplate.badge.draft'})
            : intl.formatMessage({id: 'emailTemplate.badge.usedInMarketingEmails'}, {count: usageCount}),
        states: {
            yellow: ['DRAFT'],
            green: ['USED'],
        },
    };

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'breadcrumb.marketing'}), to: '/marketing'},
        {label: intl.formatMessage({id: 'breadcrumb.templates'}), to: '/marketing/templates'},
        {label: emailTemplate.name, to: '/marketing/templates/' + emailTemplate.id},
    ]

    const secondaryNavigationItems = [
        {
            label: intl.formatMessage({id: 'tab.emailTemplate.details'}),
            to: '/marketing/templates/' + emailTemplate.id
        },
    ]

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <MarketingHeader
                type="emailTemplate"
                title={emailTemplate.name}
                identifier={emailTemplate.id}
                badge={usageBadge}
                onTitleEdit={handleTitleEdit}
                isSaving={isSaving}
            />
            <SecondaryNavigation items={secondaryNavigationItems}/>
            <div className="mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={{emailTemplate, emailLayouts}}/>
            </div>
        </>
    );
}

export default connector(EmailTemplateView);

function prepare_EmailTemplateView(params, relayEnvironment) {
    return {
        emailTemplateViewQuery: loadQuery(
            relayEnvironment,
            EmailTemplateViewQuery,
            {
                id: params.id,
            },
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_EmailTemplateView};
